import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const Container = styled.button`
  width: 100%;
  margin: 15px 0px 0px;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2px;
  color: ${theme.colors.white};
  background: none;
  cursor: pointer;
`
